
const Q = require('q');
const _ = require('lodash');
const config = require('config');

const $ = require('rgs-jquery');
const server = require('server');
const page = require('page-common');
import ko from 'rgs-knockout';
import TraceKit from 'rgs-tracekit';
const contextBar = require('context-bar');
const ContextBarContentCalcWorking = contextBar.ContentCalcWorking;

const controller = require('./js/controller.js');
const mainTemplate = require('./templates/baseMain.html');
const responseTemplate = require('./templates/response.html');
const resultTemplate = require('./templates/result.html');
const categoriesTemplate = require('./templates/categories.html');
import * as optionsTemplates from './templates/optionsTemplates/*';

function init (){
	TraceKit.notifications = true;
	const options = {};
	const initialization = ko.observable(true);
	const contextBarContentInit = new ContextBarContentCalcWorking({
		name: 'calc-feedback/init',
		above: ['default'],
		visible: initialization,
		calcWorking: {
			progress: 1,
			message: 'Идет подготовка формы...',
		},
	});
	page.contextBar.add(contextBarContentInit);
	// regions
	function initMakers (){
		return server.any.api.dictionary.makers().then(function (response){
			const data = response.responseJSON;
			options.MakersList = data;
		});
	}

	function initCategories () {
		const pretrialCategory = [{
			CategoryId: "f044de06-a113-4afa-a54a-79e40e7be10c",
			Name: "Досудебная претензия по ОСАГО",
			NotificationEmails: "rgssitemail@gmail.com",
			ParentNode: null,
			SortOrder: 1,
		}];
		const assembledCategories = _.transform(pretrialCategory, function (result, v) {
			const nodeId = (v.ParentNode || 'root').toUpperCase();
			if (!result[nodeId]) {
				result[nodeId] = [];
			}
			result[nodeId].push(v);
		});
		options.AssembledCategories = assembledCategories;
		options.defaultCategory = pretrialCategory[0].CategoryId;
	}

	function initOffices (){
		return server.any.api.offices.getAllRegions().then(function (response){
			const data = response.responseJSON;
			options.RegionsList = data.Data;
		});
	}

	function initTemplate (){
		return Q.fcall(function (){
			const container = $('#feedback-form');
			container.append(mainTemplate());
			$('#feedback-row-step-body', container).append(resultTemplate());
			$('#feedback-response-block', container).append(responseTemplate());
			container.append(categoriesTemplate());
			_.each(optionsTemplates, function (tmp){
				$('.options-categories', container).append(tmp());
			});

			options.container = container[0];
		});
	}

	function initContext () {
		const domReady = Q.Promise((resolve) => {
			$(() => resolve());
		});
		return domReady
			.then(() => {
				return JSON.parse($('#calc-feedback-context').html());
			})
			.then((context) => {
				options.context = context;
			});
	}

	const configPromise = config.cms.pageUrls.get().then((pageUrls) => {
		options.homeUrl = pageUrls.currentSite.home;
	});

	Q.all([
		initMakers(),
		initCategories(),
		initOffices(),
		initTemplate(),
		initContext(),
		configPromise,
	]).then(function (){
		const ctrl = controller(options);
		require('debug-globals').extend({ calcFeedbackController: ctrl });
		initialization(false);
	}).done();
}

init();
